class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.resizeRaf = null;
  }
  connectedCallback() {
    this.header = this.closest('#shopify-section-header');
    this.predictiveSearch = this.querySelector('predictive-search');
    this.enableStickyHeader = [true, 'true'].includes(this.dataset.enableStickyHeader);
    this.announcementBar = document.querySelector('announcement-bar');
    this.isTransparent = this.hasAttribute('data-transparent');
    this.dropdownLinks = this.querySelectorAll('[data-expand-on-hover]');
    this.overlay = this.querySelector('[data-overlay]');
    if (!this.header) return;
    this.header.classList.remove('header-visible');
    this.setHeaderOffset();
    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.scheduleHeaderOffset.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.onResizeHandler, { passive: true });
    this.dropdownLinks.forEach((link) => {
      link.addEventListener('mouseenter', (event) => this.dropdownOverlayToggle(event));
      link.addEventListener('mouseleave', (event) => this.dropdownOverlayToggle(event));
    });
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = null;
    }
  }
  scheduleHeaderOffset() {
    if (this.resizeRaf) return;
    this.resizeRaf = requestAnimationFrame(() => {
      this.resizeRaf = null;
      this.setHeaderOffset();
    });
  }
  setHeaderOffset() {
    if (!this.isTransparent || !this.header) {
      return;
    }
    const headerInner = this.header.querySelector('.header__inner');
    if (!headerInner) {
      return;
    }
    // Read layout values first
    const headerInnerHeight = headerInner.getBoundingClientRect().height;
    const isAnnouncementBelow =
    this.announcementBar?.classList.contains('announcement-bar--is-bellow') || false;
    let offset = headerInnerHeight;
    if (isAnnouncementBelow && this.announcementBar) {
      offset += this.announcementBar.getBoundingClientRect().height;
    }
    // Write styles after all reads
    if (isAnnouncementBelow && this.announcementBar) {
      const topValue = `${offset}px`;
      if (this.announcementBar.style.top !== topValue) {
        this.announcementBar.style.top = topValue;
      }
    }
    const marginValue = `-${offset}px`;
    if (this.header.style.marginBottom !== marginValue) {
      this.header.style.marginBottom = marginValue;
    }
  }
  onScroll() {
    if (!this.enableStickyHeader) {
      return;
    }
    const scrollTop = window.scrollY;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      return;
    }
    const menuOpen = this.querySelector('details[open]');
    if (menuOpen) {
      this.header.classList.add('shopify-section-header-sticky');
      return;
    }
    if (scrollTop <= 10) {
      this.header.classList.remove(
        'shopify-section-header-sticky',
        'header-slide-in'
      );
      return;
    }
    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.add('header-slide-in');
    }
  }
  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('details-disclosure');

    this.disclosures.forEach((disclosure) => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
    if (!this.searchModal) {
      return;
    }
    this.searchModal.close(false);
  }
  dropdownOverlayToggle(event) {
    if (!this.overlay) {
      return;
    }
    this.overlay.classList.toggle(
      'is-visible',
      event.type === 'mouseenter'
    );
  }
}
customElements.define('sticky-header', StickyHeader);